import { useEffect, useState } from 'react';
import { getFormattedTime } from './helpers';
import { componentService } from 'js/services/component.service';

export const AppLaunchTimer = ({ format = 'HH:mm', interval = 1000 }) => {
    const [sessionStart] = useState(Date.now());
    const [appLaunchTimer, setAppLaunchTimer] = useState(getFormattedTime(sessionStart, format), interval);

    useEffect(() => {
        const intervalId = setInterval(() => setAppLaunchTimer(getFormattedTime(sessionStart, format)), interval);

        return () => clearInterval(intervalId);
    }, [format, interval, sessionStart, appLaunchTimer]);

    return appLaunchTimer;
};

componentService.registerWebContentComponents({ AppLaunchTimer });
